var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Report__Entity" },
    [
      _c("Entity", {
        ref: "entity",
        attrs: {
          "entity-type": "Report",
          "entity-id": _vm.requestId,
          innerComponent: _vm.innerComponent,
          innerComponentTitle: "פרטים נוספים",
          title: "פרטי פנייה",
          "back-button-text": "רשימת יחידות לימוד",
          "back-button-url": "lessons",
          widgets: _vm.widgets,
          actions: _vm.actions,
          preview: _vm.preview,
          "read-only": _vm.readOnly,
          entityReady: _vm.entityReady,
          activities: [],
        },
        on: { onFormSave: _vm.onFormSave, onFormDiscard: _vm.onFormDiscard },
        scopedSlots: _vm._u([
          {
            key: "mandatory",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("מספר מזהה לפנייה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.requestId))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("תאריך פנייה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.parseDate(_vm.createdDate)))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("שם תלמיד:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.fullname))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("מייל תלמיד:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.email))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("מספר תלמיד:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.userId))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("מקור הפנייה:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.sentFromPage))]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [_vm._v("בנושא:")]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                      },
                      [_vm._v(_vm._s(_vm.messagesInCourseType))]
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }